import { Box, Drawer, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { FindingCard } from "./FindingCard";
import { applyFilters, IFilters } from "./groupFindings";
import { BLOCK_LABEL, BLOCK_ORDER, FindingDiffStatus, IEvidenceChange, ITarget } from "./raio-x.types";

interface IProps {
  open: boolean;
  target: ITarget | null;
  label: string;
  status: Map<string, FindingDiffStatus>;
  evidenceChanges: Map<string, IEvidenceChange>;
  filters: IFilters;
  workspaceLabels: Record<string, string>;
  onClose: () => void;
}

export function RaioXWorkspaceDrawer({ open, target, label, status, evidenceChanges, filters, workspaceLabels, onClose }: IProps) {
  const findings = target ? applyFilters(target.findings, filters, status) : [];
  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: "100%", md: 720 }, p: 3 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6">{label}</Typography>
        <IconButton onClick={onClose} aria-label="fechar">
          <CloseIcon />
        </IconButton>
      </Stack>
      {target?.skipped && <Typography color="text.secondary">{target.skipReason}</Typography>}
      {target &&
        !target.skipped &&
        // hazard: iterar BLOCK_ORDER em vez do próprio findings.block descarta em silêncio qualquer bloco ausente da lista (ex.: "inclusao" antes da emenda da Task 1).
        BLOCK_ORDER.map((block) => {
          const ofBlock = findings.filter((f) => f.block === block);
          if (ofBlock.length === 0) return null;
          const prescriptive = ofBlock.filter((f) => f.nature === "PRESCRIPTIVE");
          const descriptive = ofBlock.filter((f) => f.nature === "DESCRIPTIVE");
          return (
            <Box key={block} sx={{ mb: 3 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                {BLOCK_LABEL[block]}
              </Typography>
              {prescriptive.map((f) => (
                <FindingCard
                  key={f.fingerprint}
                  finding={f}
                  status={status.get(f.fingerprint)}
                  evidenceChange={evidenceChanges.get(f.fingerprint)}
                  workspaceLabels={workspaceLabels}
                />
              ))}
              {/* invariant: a marca "Para conferência" agora vem no chip de cada cartão descritivo (FindingCard);
                  uma legenda aqui repetiria a mesma marca duas vezes por achado. */}
              {descriptive.map((f) => (
                <FindingCard
                  key={f.fingerprint}
                  finding={f}
                  status={status.get(f.fingerprint)}
                  evidenceChange={evidenceChanges.get(f.fingerprint)}
                  workspaceLabels={workspaceLabels}
                />
              ))}
            </Box>
          );
        })}
      {target && !target.skipped && findings.length === 0 && <Typography color="text.secondary">Nenhum achado com os filtros atuais.</Typography>}
    </Drawer>
  );
}
